<template>
    <div>

        <div class="form-group mb-4">
            <label for="" v-if="removeTitle === false">
                <strong>
                    Estimated Route
                </strong>
            </label>
            <div class="input-group">
                <img :src="routeImagePath" style="width: 100%" alt="Image of drivers route between collection and delivery locations" />
            </div>
        </div>

        <div class="input-group mb-4">
            <label for="">
                <strong>
                    Estimated Mileage
                </strong>
            </label>

            <div class="input-group mb-2">
                <span class="input-group-text triple">
                    <img
                        src='https://maps.google.com/mapfiles/ms/icons/green-dot.png'
                        class="map-icon"
                    />
                    <span class="map-arrow"><--></span>
                    <img
                        src='https://maps.google.com/mapfiles/ms/icons/orange-dot.png'
                        class="map-icon"
                    />
                </span>
                <input class="form-control" placeholder="(awaiting route)" readonly="readonly" name="mileage" v-model="internalMileageLeg0" type="text" id="mileage">
            </div>

            <div class="input-group">
                <span class="input-group-text triple">
                    <img
                        src='https://maps.google.com/mapfiles/ms/icons/orange-dot.png'
                        class="map-icon"
                    />
                    <span class="map-arrow"><--></span>
                    <img
                        src='https://maps.google.com/mapfiles/ms/icons/red-dot.png'
                        class="map-icon"
                    />
                </span>
                <input class="form-control" placeholder="(awaiting route)" readonly="readonly" name="mileage" v-model="internalMileageLeg1" type="text" id="mileage">
            </div>

        </div>
    </div>
</template>

<style scoped>

    .map-icon {
        height: 14px;
    }

    .map-arrow {
        font-size: 8px;
    }

</style>

<script>

import { Loader } from "@googlemaps/js-api-loader";

    export default {

        props: {
            collection: {
                type: Object,
                required: true
            },
            split: {
                type: Object,
                required: false
            },
            delivery: {
                type: Object,
                required: true
            },
            removeTitle: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                internalCollection: this.collection,
                internalSplit: this.split ?? null,
                internalDelivery: this.delivery,
                routeImagePath: '/images/movements/awaiting-route-placeholder.png',
                internalMileageLeg0: 0,
                internalMileageLeg1: 0,
            }
        },

        methods: {

            async loadLibraries() {
                const [{ LatLng }, { DirectionsService }, { DirectionsStatus }, { TravelMode }, { UnitSystem }] = await Promise.all([
                    google.maps.importLibrary("core"),
                    google.maps.importLibrary("routes"),
                    google.maps.importLibrary("routes"),
                    google.maps.importLibrary("routes"),
                    google.maps.importLibrary("core"),
                ]);

                return { LatLng, DirectionsService, DirectionsStatus, TravelMode, UnitSystem };
            },

            async estimateMileage() {

                const { LatLng, DirectionsService, DirectionsStatus, TravelMode, UnitSystem } = await this.loadLibraries();
                const directionsService = new DirectionsService();

                if (this.internalCollection.lat === null || this.internalCollection.lng === null || this.internalDelivery.lat === null || this.internalDelivery.lng === null) {
                    console.warn("Collection or delivery location is missing, cannot estimate mileage");
                    return;
                }

                if ( ( this.internalCollection.lat === this.internalDelivery.lat ) && ( this.internalCollection.lng === this.internalDelivery.lng ) ) {
                    console.warn("Collection and delivery are the same location, no need to estimate mileage");
                    return;
                }

                if ( this.internalSplit === null || this.internalSplit.lat === null || this.internalSplit.lng === null) {
                    console.warn("Split location is missing, cannot estimate mileage");
                    return;
                }

                const collection = new LatLng(this.internalCollection.lat, this.internalCollection.lng);
                const delivery = new LatLng(this.internalDelivery.lat, this.internalDelivery.lng);
                const split = new LatLng(this.internalSplit.lat, this.internalSplit.lng);

                directionsService.route({
                    origin: collection,
                    waypoints: [
                        {
                            location: split
                        }
                    ],
                    destination: delivery,
                    travelMode: TravelMode.DRIVING,
                    unitSystem: UnitSystem.IMPERIAL
                }, (result, status) => {
                    if (status === DirectionsStatus.OK) {

                        const sizeWidth = '1000';
                        const sizeHeight = '450';
                        const apiKey = 'AIzaSyD_tfgEUWxTtVczG5euJnkbeZ9DryHp4F4';

                        let routeLine = result.routes[0].overview_polyline;

                        this.routeImagePath = 'https://maps.googleapis.com/maps/api/staticmap?size=' + sizeWidth + 'x' + sizeHeight +
                                            // Collection
                                            '&markers=icon:http%3A%2F%2Fmaps.google.com%2Fmapfiles%2Fms%2Ficons%2Fgreen-dot.png%7C' + this.internalCollection.lat + ',' + this.internalCollection.lng +
                                            // Split
                                            '&markers=icon:http%3A%2F%2Fmaps.google.com%2Fmapfiles%2Fms%2Ficons%2Forange-dot.png%7C' + this.internalSplit.lat + ',' + this.internalSplit.lng +
                                            // Delivery
                                            '&markers=icon:http%3A%2F%2Fmaps.google.com%2Fmapfiles%2Fms%2Ficons%2Fred-dot.png%7C' + this.internalDelivery.lat + ',' + this.internalDelivery.lng +
                                            '&path=color:0x1AB394FF%7Cenc:' + routeLine +
                                            '&key=' + apiKey;

                        for (const [l, leg] of result.routes[0].legs.entries()) {
                            // Use numeric meters from the API to avoid locale/unit text parsing issues.
                            const travelledMeters = leg.distance?.value ?? 0;
                            const travelledMiles = travelledMeters / 1609.344;
                            this[`internalMileageLeg${l}`] = Math.ceil(travelledMiles);
                        }

                        this.$emit('update-mileage', {
                            'legOne': this.internalMileageLeg0,
                            'legTwo': this.internalMileageLeg1
                        });

                    }
                    else {
                        alert(status);
                    }
                });

            },

        },

        async mounted() {

            const loader = new Loader({
                apiKey: 'AIzaSyD_tfgEUWxTtVczG5euJnkbeZ9DryHp4F4',
                version: "weekly",
                libraries: ["places", "geocoding", "maps", "marker"],
            });

            // This is used literally as a way to detect Google is loaded. We don't actually need to load a library here
            await loader.importLibrary('places');
            await this.estimateMileage();

        },

        watch: {
            collection: {
                handler: function (val) {
                    this.internalCollection = val;
                    this.estimateMileage();
                },
                deep: true
            },
            split: {
                handler: function (val) {
                    this.internalSplit = val;
                    this.estimateMileage();
                },
                deep: true
            },
            delivery: {
                handler: function (val) {
                    this.internalDelivery = val;
                    this.estimateMileage();
                },
                deep: true
            }
        }

    }
</script>
